import { FC, useMemo, useCallback } from "react";
import { Stack } from "@mui/material";
import { utilizationAndCoverageDrawerDataGridColumnDefs } from "./columns/utilizationAndCoverageDrawerDataGridColumnDefs";
import { CommitmentsGridLoadingLayer } from "../../../../../common/components/data-grid/CommitmentsGridLoadingLayer";
import { CommitmentsDrawerAGGridToolbar } from "../../../../../common/components/drawer/data-grid/CommitmentsDrawerAGGridToolbar";
import { CommitmentsAgGrid } from "../../../../../common/components/CommitmentsAgGrid";
import { useAppSelector } from "@/store/hooks";
import { utilizationAndCoverageDetailsCoverageDataSelector } from "@/store/commitments/selectors/coverage-and-utilization/details-drawer/data/utilizationAndCoverageDetailsCoverageDataSelector";
import { commitmentsDetailsDrawerCoverageGroupingSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerCoverageGroupingSelector";
import { utilizationAndCoverageDetailsLoadingSelector } from "@/store/commitments/selectors/coverage-and-utilization/details-drawer/data/utilizationAndCoverageDetailsLoadingSelector";
import {
  CommitmentsDetailsRequestData,
  DataViewTab,
} from "@/store/commitments/utils/types/types";
import { SavingsPlanCoverageDataWithId } from "@/components/pages/commtiments/common/utils/types";
import { getCommitmentDetailsRequestDataFromSavingsPlanCoverage } from "@/components/pages/commtiments/utilization-and-coverage/utils/helpers/getCommitmentDetailsRequestDataFromSavingsPlanCoverage";

interface UtilizationAndCoverageDrawerDataGridProps {
  viewTab: DataViewTab;
}

export const UtilizationAndCoverageDrawerDataGrid: FC<
  UtilizationAndCoverageDrawerDataGridProps
> = ({ viewTab }) => {
  const data = useAppSelector(
    utilizationAndCoverageDetailsCoverageDataSelector,
  );
  const loading = useAppSelector(utilizationAndCoverageDetailsLoadingSelector);
  const grouping = useAppSelector(
    commitmentsDetailsDrawerCoverageGroupingSelector,
  );

  const columnDefs = useMemo(() => {
    return (
      utilizationAndCoverageDrawerDataGridColumnDefs?.[viewTab]?.[grouping] ??
      []
    );
  }, [grouping, viewTab]);

  const clickHandlerDataGetter = useCallback(
    (data: SavingsPlanCoverageDataWithId): CommitmentsDetailsRequestData =>
      getCommitmentDetailsRequestDataFromSavingsPlanCoverage(data, grouping),
    [grouping],
  );

  if (!columnDefs) {
    return null;
  }

  return (
    <Stack
      p={1.5}
      pt={0}
      zIndex={1}
      height="100%"
      minHeight={400}
      position="relative"
    >
      {loading && <CommitmentsGridLoadingLayer />}
      <CommitmentsAgGrid
        inDrawer
        data={data}
        loading={loading}
        grouping={grouping}
        columnDefs={columnDefs}
        Toolbar={CommitmentsDrawerAGGridToolbar}
        clickHandlerDataGetter={clickHandlerDataGetter}
        localStorageUniqueKey={`savingsPlanDataGrid-${viewTab}`}
        overrideWrapperStyles={overrideWrapperStyles}
      />
    </Stack>
  );
};
const overrideWrapperStyles = {
  "& .ag-root-wrapper": {
    borderRadius: 2,
    border: 1,
    borderColor: "grey.300",
  },
};
